var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6436 13C22.6436 18.523 18.1666 23 12.6436 23C7.12075 23 2.64355 18.523 2.64355 13C2.64355 7.4772 7.12075 3 12.6436 3C18.1666 3 22.6436 7.4772 22.6436 13Z",
    fill: "#C0392B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6436 12C22.6436 17.523 18.1666 22 12.6436 22C7.12075 22 2.64355 17.523 2.64355 12C2.64355 6.4772 7.12075 2 12.6436 2C18.1666 2 22.6436 6.4772 22.6436 12Z",
    fill: "#E74C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69385 9.40002L11.2295 13L7.69385 16.5L9.10805 17.9L12.6435 14.4L16.1795 17.9L17.5935 16.5L14.0575 13L17.5935 9.40002L16.1795 8L12.6435 11.5L9.10805 8L7.69385 9.40002Z",
    fill: "#C0392B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69385 8.40002L11.2295 12L7.69385 15.5L9.10805 16.9L12.6435 13.4L16.1795 16.9L17.5935 15.5L14.0575 12L17.5935 8.40002L16.1795 7L12.6435 10.5L9.10805 7L7.69385 8.40002Z",
    fill: "#ECF0F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.afcdbed76c154a07c2623ca3acd9de73.svg";
export { ForwardRef as ReactComponent };